import React from 'react'
import { useHistory } from 'react-router-dom'
import PagePolicyPrivacy from '../../../../../presentation/pages/common/amplify/policyPrivacy'

const MakePolicyPrivacy = () => {
  const history = useHistory()

  const handleGoBack = () => {
    history.goBack()
  }

  return <PagePolicyPrivacy handleGoBack={handleGoBack} />
}

export default MakePolicyPrivacy
